import { createStore } from 'satcheljs';
import OwaLayoutStore from './schema/owaLayoutStore';

const owaLayoutStore: OwaLayoutStore = {
    browserWidthBucket: null,
    areDisplayAdsEnabled: false,
};

export let getStore = createStore<OwaLayoutStore>('OwaLayout', owaLayoutStore);
